<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[5]" :innerTitle="navList[5].navChildList[1].name" :innerLink="navList[5].navChildList[1].toLink"></inner-nav>
      <div class="recruit-content">
        <div class="recruit-detail">
          <img :src="recruitAd.imgUrl" alt="">
          <div class="recruit-list">
            <div class="recruit-list-title">
              <ul>
                <li>职位名称</li>
                <li>工作地点</li>
                <li>招聘人数</li>
                <li>年龄需求</li>
                <li>投递简历</li>
                <li>发布时间</li>
              </ul>
            </div>

            <el-collapse accordion>
              <el-collapse-item v-for="(item,index) in recruitList" :key="index">
                <template slot="title">
                  <ul class="recruit-item">
                    <li>{{item.postName}}</li>
                    <li>{{item.workLocation}}</li>
                    <li>{{item.recruitNumber}}人</li>
                    <li>{{item.ageRandom}}</li>
                    <li>{{item.resumeAccept}}</li>
                    <li>{{item.publicDate}}</li>
                  </ul>
                </template>
                <div class="item_content" v-html="item.content">
                  {{item.content}}
                </div>
              </el-collapse-item>
            </el-collapse>

            <div class="news-pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="changePage"
                :total="totalPage">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  import {mapGetters,mapActions} from "vuex";
  export default {
    name: "",
    data(){
      return {
        recruitAd:{}
      }
    },
    computed: {
      ...mapGetters('recruit', ['recruitList','totalPage'])
    },
    components: {
      ad,
      InnerNav
    },
    methods:{
      ...mapActions('recruit',['recruitListFn']),
      changePage(e){
        this.recruitListFn(e);
      }
    },
    created(){
      this.recruitListFn(1);
      this.$http.get(`/outer/image/listImages.do`,{
        functionCode:5
      }).then((res)=>{
        this.recruitAd=res.data[0]
      })
    }
  }
</script>

<style scoped lang="less">
  .recruit-content{
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .recruit-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .recruit-detail{
        width:12rem;
          img {
            width:100%;
            height:2.2rem;
            margin-bottom:.1rem;
          }
          .recruit-list-title{
            width:100%;
            height:.76rem;
            background:#666;
              ul{
                width:98%;
                  li{
                    float: left;
                    width:16%;
                    font-size:.16rem;
                    font-weight:500;
                    color:#fff;
                    line-height:.76rem;
                    text-align: center;
                  }
              }

          }
          .recruit-item{
            width:100%;
              li{
                float: left;
                width:16%;
                text-align: center;
              }
          }
      }


  }

</style>

<style lang="less">
  .news-pagination{
    text-align: center;
    padding-top:.4rem;
      .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #F53A37;
      }
      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
        border-radius: 50%;
        height: .24rem;
        width:.24rem;
        min-width: .24rem;
        line-height:.24rem;
      }
      .el-pagination.is-background .el-pager li:not(.disabled):hover{
        color: #000;
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
        background-color: #F53A37;
        color: #fff;
      }
  }
  .el-collapse-item{
    .el-collapse-item__content{
      background: #F5F5F5;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      padding:.3rem .5rem;
        .item_content{
          font-size:.14rem;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/recruit/personnel-recruit.vue